module.exports = __webpack_public_path__ + "static/img/Caleb-Serong.fc5a484.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Caleb-Serong.jpg
// module id = EcR2
// module chunks = 0